// components/Footer.jsx
// Adds footer to the page


export default function Footer() {
    return (
      <footer className="footer w-full text-gray-400 text-center py-4 mt-auto">
        © {new Date().getFullYear()} Kdramarama. All rights reserved.
      </footer>
    );
  }
  
